/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Desktop = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M4 22V20.5H9.5V18H1V2H23V18H14.5V20.5H20V22H4ZM13 18H11V20.5H13V18ZM21.5 3.5H2.5V16.5H21.5V3.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
